module.exports = __webpack_public_path__ + "media/music/saw_lead_7-88e00cb3.mp3";